// Homepage category cards + life-stage timeline
export const CATEGORY_CARDS = [
  {
    id: "wedding",
    title: "IK GA TROUWEN",
    subtitle: "Huwelijksfotografie",
    slug: "huwelijk",
    image: "https://customer-assets.emergentagent.com/job_capture-memories-11/artifacts/bbztf8ya_0B5A9361%20kopie2.jpg",
  },
  {
    id: "pregnancy",
    title: "WE VERWACHTEN EEN KINDJE",
    subtitle: "Zwangerschap & Newborn",
    slug: "zwangerschap",
    image: "https://customer-assets-eiarnc6j.emergentagent.net/job_capture-memories-11/artifacts/hpwmyzd5_0B5A1126%20kopie2.webp",
  },
  {
    id: "pets",
    title: "MIJN HUISDIER IS FAMILIE",
    subtitle: "Honden • Katten • Paarden",
    slug: "huisdieren",
    image: "https://customer-assets.emergentagent.com/job_capture-memories-11/artifacts/0rpfhm02_IMG_3001%20%281%29.webp",
  },
  {
    id: "family",
    title: "MIJN GEZIN",
    subtitle: "Gezinsfotografie",
    slug: "gezin",
    image: "https://images.pexels.com/photos/8730072/pexels-photo-8730072.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=900",
  },
  {
    id: "events",
    title: "IK ORGANISEER EEN FEEST",
    subtitle: "Events • Magic Mirror Fotobooth • Audio Gastenboek",
    slug: "events",
    image: "https://customer-assets.emergentagent.com/job_capture-memories-11/artifacts/7goxnl6a_0B5A0628%20kopie.webp",
  },
  {
    id: "corporate",
    title: "MIJN BEDRIJF",
    subtitle: "Bedrijfsfotografie",
    slug: "bedrijven",
    image: "https://customer-assets-eiarnc6j.emergentagent.net/job_capture-memories-11/artifacts/qembwk4n_Opdracht%20%2890%29%20kopie%20-%20kopie.webp",
  },
];

export const TIMELINE = [
  { title: "Zwangerschap", icon: "Heart" },
  { title: "Newborn", icon: "Baby" },
  { title: "Cake Smash", icon: "Cake" },
  { title: "Gezin", icon: "Users" },
  { title: "Communie / Lentefeest", icon: "Sparkles" },
  { title: "Huwelijk", icon: "Gem" },
  { title: "Eigen Kinderen", icon: "Smile" },
  { title: "Huisdieren", icon: "PawPrint" },
  { title: "Familie", icon: "Home" },
];
